import {
    GATE_PASS_LOADING,
    FETCH_GATE_PASS_MASTER_SUCCESS,
    FETCH_SINGLE_GATE_PASS_SUCCESS,
    FETCH_GATE_PASS_STATUS_DROPDOWN_SUCCESS,
    FETCH_PENDING_STYLE_SALE_ORDER_SUCCESS,
    FETCH_PENDING_STYLE_SALE_ORDER_REQUEST,
    FETCH_PENDING_STYLE_SALE_ORDER_FAILURE,
    CREATE_GATE_PASS_FORM,
    SET_UNIT_NAME_GATE_PASS,
    SET_START_DATE_GATE_PASS,
    SET_END_DATE_GATE_PASS,
    GATE_PASS_USERFORM_RESET,
    NAVIGATE_GATE_PASS_DETAILS,
    NAVIGATE_GATE_PASS_MASTER,
    GATE_PASS_DETAILS_LOADING,
    FETCH_GATE_PASS_DETAILS_SUCCESS,
    CREATE_GATE_PASS_DETAILS_FORM,
    SET_GATE_PASS_DETAILS_FORM,
    GATE_PASS_DETAILS_FORM_RESET,
    NAVIGATE_GATE_PASS_PRINT,
    GATE_PASS_AUTHORIZED_SUCCESS
} from './gatePass.actionsType';

// TODO: register this string as the key for this reducer in your root
// combineReducers({ ..., [GATE_PASS]: gatePassReducer }) — the component
// files below read state via this same constant, so keep them in sync.
export const GATE_PASS = 'GATE_PASS';

const initialFormState = {
    fldGatePassNo: '',
    fldGatePassDate: new Date().toISOString().split('T')[0],
    fldFKUnitId: '',
    fldFKProgram: '',
    fldFKSupplierID: '',
    fldFKDeliveryAt: '',
    fldFKStatus: '',
    fldIsReturnable: false,
    fldIsActive: true,
    fldVehicleNO: '',
    fldPurpose: '',
    fldDeliveryStartDate: '',
    fldDeliveryEndDate: '',
    fldTotalQty: 0,
    fldInwardQty: 0,
    fldCancelQty: 0,
    fldBalanceQty: 0,
    fldTakenBy: '',
    fldTakenDate: '',
    fldApprovedBy: '',
    fldApprovedDate: '',
    fldGateVerifyBy: '',
    fldGateVerifyDate: '',
    fldInwardBy: '',
    fldInwardDate: '',
    fldReturnBy: '',
    fldReturnDate: '',
    fldRemarks: ''
    // Denormalized Unit/Supplier/DeliveryAt address+GST+PAN fields are filled
    // in at submit time from the selected dropdown record (see the Grid
    // component's buildSnapshotFields helper) rather than kept here — they
    // are never typed directly.
};

// Detail row form — same fields as the General DC details form.
export const initialDetailsFormState = {
    fldFKGeneralHeader: '',
    fldGeneralHeader: '',
    fldFKGeneralItem: '',
    fldGeneralItem: '',
    fldItemDescription: '',
    fldFKHSNCode: '',
    fldFKColour: '',
    fldFKSize: '',
    fldSize: '',
    fldFKUOM: '',
    fldQuantity: 0,
    fldRate: '',
    fldGrossValue: 0,
    fldDiscountPercentage: '',
    fldDiscountValue: '',
    fldTaxableValue: 0,
    fldIGSTPercentage: 0,
    fldIGSTValue: 0,
    fldSGSTPercentage: 0,
    fldSGSTValue: 0,
    fldCGSTPercentage: 0,
    fldCGSTValue: 0,
    fldGSTValue: 0,
    fldTotalValue: 0,
    fldRemarks: ''
};

const initialState = {
    loading: false,
    unitId: '',
    startDate: new Date(new Date().setDate(new Date().getDate() - 15)),
    endDate: new Date(),
    gatePassMaster: [],
    gatePassForm: initialFormState,
    statusDropdown: [],
     pendingStyleSaleOrderList: [],
    // detail page
    isGatePassDetails: false,
    isGatePassPrint: false,
    selectedGatePass: null,
    detailsLoading: false,
    gatePassDetails: [],
    gatePassDetailsForm: initialDetailsFormState
};

export let gatePassReducer = (state = initialState, action) => {
    const { type, payload, updatePayload, key, value } = action;

    switch (type) {
        case GATE_PASS_LOADING:
            return { ...state, loading: payload };

        case FETCH_GATE_PASS_MASTER_SUCCESS:
            return { ...state, gatePassMaster: payload };

        case FETCH_SINGLE_GATE_PASS_SUCCESS:
            return { ...state, gatePassForm: { ...initialFormState, ...payload } };

        case FETCH_GATE_PASS_STATUS_DROPDOWN_SUCCESS:
            return { ...state, statusDropdown: payload };

        case CREATE_GATE_PASS_FORM:
            return { ...state, gatePassForm: { ...state.gatePassForm, [key]: value } };

        case SET_UNIT_NAME_GATE_PASS:
            return { ...state, unitId: payload };

        case SET_START_DATE_GATE_PASS:
            return { ...state, startDate: payload };

        case SET_END_DATE_GATE_PASS:
            return { ...state, endDate: payload };

        case GATE_PASS_USERFORM_RESET:
            return { ...state, gatePassForm: initialFormState };
        
        case FETCH_PENDING_STYLE_SALE_ORDER_SUCCESS:
            console.log('payload',updatePayload);
            return {                
                ...state, pendingStyleSaleOrderList: updatePayload };
        // ---- detail page ----
        case NAVIGATE_GATE_PASS_DETAILS:
            return {
                ...state,
                isGatePassDetails: true,
                isGatePassPrint: false,
                selectedGatePass: payload,
                gatePassDetails: [],
                gatePassDetailsForm: initialDetailsFormState
            };
        case NAVIGATE_GATE_PASS_MASTER:
            return { ...state, isGatePassDetails: false, isGatePassPrint: false, selectedGatePass: null, gatePassDetails: [] };
        case GATE_PASS_AUTHORIZED_SUCCESS:
            // mark the gate pass authorized on the print page and in the list
            return {
                ...state,
                selectedGatePass:
                    state.selectedGatePass && String(state.selectedGatePass.fldId) === String(payload)
                        ? { ...state.selectedGatePass, fldIsAuthorized: true }
                        : state.selectedGatePass,
                gatePassMaster: (state.gatePassMaster || []).map((r) =>
                    String(r.fldId ?? r.FldId) === String(payload) ? { ...r, fldIsAuthorized: true, FldIsAuthorized: true } : r
                )
            };
        case NAVIGATE_GATE_PASS_PRINT:
            return { ...state, isGatePassPrint: true, isGatePassDetails: false, selectedGatePass: payload, gatePassDetails: [] };
        case GATE_PASS_DETAILS_LOADING:
            return { ...state, detailsLoading: payload };
        case FETCH_GATE_PASS_DETAILS_SUCCESS:
            return { ...state, gatePassDetails: payload };
        case CREATE_GATE_PASS_DETAILS_FORM:
            return { ...state, gatePassDetailsForm: { ...state.gatePassDetailsForm, [key]: value } };
        case SET_GATE_PASS_DETAILS_FORM:
            return { ...state, gatePassDetailsForm: { ...initialDetailsFormState, ...payload } };
        case GATE_PASS_DETAILS_FORM_RESET:
            return { ...state, gatePassDetailsForm: initialDetailsFormState };

        case FETCH_PENDING_STYLE_SALE_ORDER_REQUEST:            
        case FETCH_PENDING_STYLE_SALE_ORDER_FAILURE:
        default:
            return state;
    }
};